module.exports = __webpack_public_path__ + "static/media/blocks.23580ccd.svg";